.layout {
  display: grid;
  gap: var(--sp-10);
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 18rem), 1fr));
}
.photoWrap {
  max-width: 20rem;
}
.content {
  grid-column: span 2;
}
.content :global(.prose) {
  margin-top: var(--sp-6);
}
/* Hometown and the "interesting anecdotes" from the old bio pages. */
.facts {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
  margin-top: var(--sp-6);
}
.facts li {
  padding: var(--sp-1) var(--sp-3);
  border: 1px solid var(--border);
  border-radius: 999px;
  color: var(--text);
  font-size: var(--fs-sm);
}
